import React, { Suspense } from 'react';

import {
  Content,
  HStack,
  Header,
  LinkButton,
  PageTitle,
  SidebarTrigger,
  TableSkeleton,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@eluve/components';
import { useCaptureEventOnMount } from '@eluve/posthog-react';
import {
  useIsEluveAdmin,
  useIsPromptTemplateCreator,
} from '@eluve/session-helpers';

import { TenantOutputTemplatesList } from './TenantOutputTemplatesList';

export interface TenantOutputTemplatesListPageProps {}

export const TenantOutputTemplatesListPage: React.FC<
  TenantOutputTemplatesListPageProps
> = () => {
  useCaptureEventOnMount('page_view_output_templates_list');
  const isTemplateCreator = useIsPromptTemplateCreator();
  const isEluveAdmin = useIsEluveAdmin();

  const isCreateTemplateDisabled = !(isEluveAdmin || isTemplateCreator);

  return (
    <>
      <Header>
        <SidebarTrigger />
        <PageTitle>Templates</PageTitle>
        <HStack justify="end">
          <Tooltip>
            <TooltipTrigger asChild>
              <LinkButton
                to="create"
                text="Create Template"
                disabled={isCreateTemplateDisabled}
              />
            </TooltipTrigger>
            {isCreateTemplateDisabled && (
              <TooltipContent>
                You do not have permission to create templates. Please contact
                your organizations administrator.
              </TooltipContent>
            )}
          </Tooltip>
        </HStack>
      </Header>
      <Content padded>
        <Suspense fallback={<TableSkeleton numRows={20} />}>
          <TenantOutputTemplatesList />
        </Suspense>
      </Content>
    </>
  );
};
